/**
 * Zod-freier Unterpfad `@asas/domain/ap-import-gruende` für den Browser
 * (AC-302, Regel 27): warum der Server einen Import abweist. Die API gibt den
 * Grund als `data.apImport.grund` aus, die Oberfläche formuliert ihn.
 */
/** Größe der hochgeladenen Datei (E7) — eine Grenze für Ansicht, Eingabe und Leser. */
export const AP_IMPORT_DATEI_MAX_BYTES = 5 * 1024 * 1024;

export const AP_IMPORT_ABWEISUNGEN = [
  /** `tenant_settings.ap_import` ist leer (E10). */
  'nicht_eingerichtet',
  /** Die Datei ist keine xlsx-Arbeitsmappe (E7). */
  'kein_xlsx',
  /** Die Mappe enthält Makros (E7). */
  'makros',
  /** Datei oder entpackter Inhalt über der Grenze (E7). */
  'zu_gross',
  /** Mehr Blätter als erlaubt (E7). */
  'zu_viele_blaetter',
  /** Zip oder XML nicht lesbar. */
  'beschaedigt',
  /** Bibliothek, Gewerke oder Konfiguration haben sich seit der Vorschau geändert (E1). */
  'vorschau_veraltet',
  /** Der Lauf ist schon übernommen (E1). */
  'bereits_uebernommen',
] as const;
export type ApImportAbweisung = (typeof AP_IMPORT_ABWEISUNGEN)[number];

export function istApImportAbweisung(wert: unknown): wert is ApImportAbweisung {
  return AP_IMPORT_ABWEISUNGEN.some((bekannt) => bekannt === wert);
}
